export const DOCUMENT_TYPES = Object.freeze({
  PASSPORT: "Passport",
  ID_CARD: "ID Card",
  DRIVER_LICENSE: "Driver License",
});

const ALL_DOCUMENT_TYPES = Object.freeze([
  DOCUMENT_TYPES.PASSPORT,
  DOCUMENT_TYPES.ID_CARD,
  DOCUMENT_TYPES.DRIVER_LICENSE,
]);

const MULTI_DOCUMENT_COUNTRIES = Object.freeze([
  ["RO", "ROU", "Romania", "罗马尼亚"],
  ["SE", "SWE", "Sweden", "瑞典"],
  ["BE", "BEL", "Belgium", "比利时"],
  ["PT", "PRT", "Portugal", "葡萄牙"],
  ["CZ", "CZE", "Czech Republic", "Czechia", "捷克共和国", "捷克"],
  ["NL", "NLD", "Netherlands", "The Netherlands", "荷兰"],
  ["AE", "ARE", "UAE", "United Arab Emirates", "阿拉伯联合酋长国", "阿联酋"],
  ["ES", "ESP", "Spain", "西班牙"],
  ["SG", "SGP", "Singapore", "新加坡"],
  ["HK", "HKG", "Hong Kong", "Hong Kong SAR", "中国香港", "香港"],
  ["NZ", "NZL", "New Zealand", "新西兰"],
  ["MX", "MEX", "Mexico", "墨西哥"],
  ["CA", "CAN", "Canada", "加拿大"],
  ["US", "USA", "United States", "United States of America", "美国"],
  ["GB", "GBR", "UK", "United Kingdom", "Great Britain", "英国"],
  ["JP", "JPN", "Japan", "日本"],
  ["EE", "EST", "Estonia", "爱沙尼亚"],
  ["PL", "POL", "Poland", "波兰"],
  ["AU", "AUS", "Australia", "澳大利亚"],
  ["FR", "FRA", "France", "法国"],
  ["DE", "DEU", "Germany", "德国"],
  ["IT", "ITA", "Italy", "意大利"],
  ["IE", "IRL", "Ireland", "爱尔兰"],
]);

export const MULTI_DOCUMENT_COUNTRY_COUNT = MULTI_DOCUMENT_COUNTRIES.length;

const normalizeLookupValue = (value) =>
  String(value || "")
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim()
    .toUpperCase()
    .replace(/[^A-Z0-9\u3400-\u9FFF]/g, "");

const SUPPORTED_COUNTRY_KEYS = new Set(
  MULTI_DOCUMENT_COUNTRIES.flat().map(normalizeLookupValue),
);

const readCountryValue = (country) => {
  if (!country || typeof country !== "object") return country;

  return (
    country.countryCode || country.code || country.value || country.name || ""
  );
};

export const supportsMultipleDocumentTypes = (country) =>
  SUPPORTED_COUNTRY_KEYS.has(normalizeLookupValue(readCountryValue(country)));

export const getAllowedDocumentTypes = (country) =>
  supportsMultipleDocumentTypes(country)
    ? [...ALL_DOCUMENT_TYPES]
    : [DOCUMENT_TYPES.PASSPORT];

export const normalizeDocumentType = (value) => {
  const normalized = normalizeLookupValue(value);

  if (normalized.includes("PASSPORT") || normalized.includes("护照")) {
    return DOCUMENT_TYPES.PASSPORT;
  }
  if (
    normalized.includes("DRIVER") ||
    normalized.includes("DRIVING") ||
    normalized.includes("驾照") ||
    normalized.includes("驾驶证")
  ) {
    return DOCUMENT_TYPES.DRIVER_LICENSE;
  }
  if (
    normalized.includes("IDENTITY") ||
    normalized.includes("IDCARD") ||
    normalized === "ID" ||
    normalized.includes("身份证")
  ) {
    return DOCUMENT_TYPES.ID_CARD;
  }

  return "";
};

export const documentRequiresBack = (documentType) => {
  const normalized = normalizeDocumentType(documentType);
  return (
    normalized === DOCUMENT_TYPES.ID_CARD ||
    normalized === DOCUMENT_TYPES.DRIVER_LICENSE
  );
};

export const getInitialDocumentType = (country, documentType) => {
  const allowedTypes = getAllowedDocumentTypes(country);
  const normalizedType = normalizeDocumentType(documentType);

  if (allowedTypes.includes(normalizedType)) return normalizedType;
  return allowedTypes[0];
};
